import { Button, Inline } from "@seneca/senekit";

import { ProviderSSO } from "services/firebase/auth/types";

export type Props = {
  provider: ProviderSSO;
  providerDisplayName: string;
  icon: any;
  signInWith: (
    provider: ProviderSSO,
    signInWithRedirect?: boolean
  ) => Promise<void>;
  selectedProvider?: string;
  signInWithRedirect?: boolean;
};

export default function SignUpFormButton({
  provider,
  providerDisplayName,
  icon: Icon,
  signInWith,
  selectedProvider,
  signInWithRedirect
}: Props) {
  return (
    <Button
      type="button"
      onClick={() => signInWith(provider, signInWithRedirect)}
      fill="outlined"
      width="100%"
      loading={selectedProvider === provider}
      disabled={!!selectedProvider && selectedProvider !== provider}
    >
      <Inline space="large" alignItems="center" flexWrap="nowrap">
        <Icon display="block" width="20px" height="20px" />
        {"Continue with " + providerDisplayName}
      </Inline>
    </Button>
  );
}
